const rolesWebCId = {
  accion: [
    { path: "/" },
    { path: "/envio" },
    { path: "/alarmas" },
    { path: "/ayuda" },
    // { path: "/remitentes", sub: null },
    // { path: "/destinatarios", sub: null },
    {
      path: "/pre-registro",
      sub: [{ path: "/remitentes" }, { path: "/destinatarios" }],
    },
    {
      path: "/material",
      sub: [{ path: "/historial" }],
    },
  ],
  label: "Usuario",
};

export default rolesWebCId;
